import React from "react";
import PuffLoader from "react-spinners/PuffLoader";

const Loading = () => {
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-gradient-to-br from-[#7f1d1d] via-[#be123c] to-[#831843] overflow-hidden">

      {/* Floating glow blobs */}
      <div className="absolute -top-20 -left-20 w-96 h-96 bg-pink-500/30 rounded-full blur-3xl animate-pulse" />
      <div className="absolute bottom-[-80px] right-[-80px] w-96 h-96 bg-red-500/30 rounded-full blur-3xl animate-pulse" />

      {/* Glass card */}
      <div className="relative flex flex-col items-center justify-center px-16 py-14 rounded-3xl backdrop-blur-xl bg-white/10 border border-white/20 shadow-2xl">

        <PuffLoader 
          color="#ffd1dc" 
          size={130} 
          speedMultiplier={1.3} 
        />

        <p className="mt-6 text-lg font-semibold tracking-wide text-pink-100">
          সিস্টেম লোড হচ্ছে...
        </p>

        <span className="mt-1 text-sm text-pink-200/80">
          অনুগ্রহ করে অপেক্ষা করুন
        </span>
      </div>
    </div>
  );
};

export default Loading;
